import { sliceDataByDateRange } from './periodCompare';
import { computeAllInsights } from './insights';
import { generateNarrative, formatPeriodLabel } from './narrativeSummary';
import { t } from './i18n';

const formatKm = (km) => {
  if (!km || km < 0.1) return '—';
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
};

export const buildPrintSummary = (data = {}, range = {}, { title } = {}) => {
  const periodData = sliceDataByDateRange(data, range);
  const insights = computeAllInsights(periodData);
  const totalKm = Object.values(insights.distanceByType || {}).reduce((a, b) => a + (Number(b) || 0), 0);

  const narrative = generateNarrative({
    range,
    cities: insights.cities,
    distanceByType: insights.distanceByType,
    music: insights.music,
    entertainment: insights.entertainment,
    concerts: insights.concerts,
    diary: periodData.diary || [],
  });

  return {
    title: title || t('web.print.periodSummary'),
    periodLabel: formatPeriodLabel(range),
    narrative,
    stats: [
      { label: 'Cidades visitadas', value: insights.cities.length },
      { label: t('web.print.distance'), value: formatKm(totalKm) },
      { label: 'Dias ativos', value: insights.mostActiveDays.length },
      { label: t('web.print.musicPlays'), value: insights.music.totalPlays },
      { label: 'Filmes', value: insights.entertainment.totalMovies },
      { label: t('web.print.episodes'), value: insights.entertainment.totalEpisodes },
      { label: 'Shows', value: insights.concerts.totalConcerts },
      { label: t('web.print.diaryEntries'), value: (periodData.diary || []).length },
    ],
    topCities: (insights.cities || []).slice(0, 10),
    topVenues: (insights.topVenues || []).slice(0, 10),
    activeDays: (insights.mostActiveDays || []).slice(0, 15),
  };
};
